import React from 'react'
import { DeletButtonStyle } from './DeleteButton.styled'

const DeleteButton = ({btnText="",onClick,disabled=false}) => {
  return (
    <DeletButtonStyle onClick={onClick} disabled={disabled}>
        {btnText}
    </DeletButtonStyle>
  )
}

export default DeleteButton